// reducers/openPopupReducer.js

import { CLOSE_OPEN_POPUP, SET_OPEN_POPUP } from 'actions/types';

const initialState = {
  open: false,
  data: {}, // data: { title, content, footer, size }
};

const openPopupReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPEN_POPUP:
      return {
        ...state,
        open: true,
        data: action.payload,
      };
    case CLOSE_OPEN_POPUP:
      return {
        ...state,
        open: false,
        data: {},
      };
    default:
      return state;
  }
};

export default openPopupReducer;
